import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_freemium_site.component.html'
})
export class SetFreemiumSiteModalComponent extends BaseSupportModalComponent {
	siteId: string;
	inFreemiumMode: boolean;

	async ok() {
		await this.supportService.setFreemiumSite(this.siteId, !this.inFreemiumMode, this.spreader.base.comment).toPromise();

		this.execute();
	}
}
